var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useApolloClient, gql } from '@apollo/client';
export function useApiKey(id) {
    const { cache } = useApolloClient();
    const response = cache.readFragment({
        id: `WebApiClient:${id}`,
        fragment: gql `
      fragment MyWebApiClient on WebApiClient {
        id
        clientId
        clientSecret
        name
        description
        createdBy
        createdByCompanyUser {
          user {
            name
          }
        }
      }
    `,
    });
    if (response) {
        const _a = response || {}, { createdByCompanyUser } = _a, rest = __rest(_a, ["createdByCompanyUser"]);
        const { name: userName = '' } = (createdByCompanyUser === null || createdByCompanyUser === void 0 ? void 0 : createdByCompanyUser.user) || {};
        return Object.assign(Object.assign({}, rest), { userName });
    }
    return null;
}
